import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ps-recipe-instructions" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Instructions", -1)),
    _createElementVNode("div", {
      class: "content",
      innerHTML: _ctx.renderedInstructions
    }, null, 8, _hoisted_2)
  ]))
}